// TODO: Duplicated on panel-members library. Extract to shared library
export enum ProjectAnswerStatus {
  Incomplete = 1,
  Terminated = 2,
  Quota = 3,
  Qualified = 4,
  Flagged = 5,
  AlreadyAnswered = 6,
  Rejected = 7,
  Failed = 8,
  Expired = 9
}
